import React from 'react';
import HRLeavePage from '../pages/leave-management';
import ProtectedRoute from './protected';

export const LeaveRoutes = [
  <ProtectedRoute exact path='/leave' component={HRLeavePage} />,
];